import { useLang } from "../lib/i18n";
import { IMAGES } from "../lib/images";
import { Systems, ColourPalette } from "./Fenetres";

export default function Accessoires() {
  const { t } = useLang();
  const c = t.accessoiresPage.colours;
  return (
    <>
      <Systems s={t.accessoiresPage.systems} images={IMAGES.accessoiresPage.systems} />
      <ColourPalette
        c={c}
        downloads={[
          { label: c.downloadCatalogue, href: "/documents/acc-catalogue.pdf" },
          { label: c.downloadBso, href: "/documents/bso-colors.pdf" },
        ]}
      />
    </>
  );
}
